module.exports = __webpack_public_path__ + "static/media/cafe_2.337b105e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/cafe_2.jpg
// module id = 652
// module chunks = 0